// extracted by mini-css-extract-plugin
module.exports = {"baseColor":"#007bff"};